import { render, staticRenderFns } from "./OnlineCustomWidget.vue?vue&type=template&id=68501c88&"
import script from "./OnlineCustomWidget.vue?vue&type=script&lang=js&"
export * from "./OnlineCustomWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports